<template>
  <v-menu
    v-model="open"
    max-width="230px"
    :close-on-content-click="true"
    offset-y
    content-class="box_menu"
    rounded="lg"
  >
    <template #activator="{ on, attrs }">
      <v-btn
        style="background: transparent;"
        elevation="0"
        v-bind="attrs"
        v-on="on"
        @click="$emit('open')"
      >
        <v-icon
          :id="id"
        >
          {{ icon }}
        </v-icon>
      </v-btn>
    </template>

    <template>
      <v-list>
        <v-list-item
          v-for="(item, index) in items"
          :id="item.id"
          :key="index"
          @click="() => handleClick(item?.action)"
        >
          <v-list-item-icon v-if="item?.icon">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title v-if="item?.title">
            {{ item.title }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </template>
  </v-menu>
</template>

<script>
export default {
  emits: ['close', 'open'],
  props: {
    options: {
      type: Array,
      required: true
    },
    id: {
      type: String,
      required: false,
      default: 'menu_actions'
    },
    icon: {
      type: String,
      required: false,
      default: 'more_vert'
    }
  },
  data () {
    return {
      open: false
    }
  },
  computed: {
    items () {
      const hasCondition = this.options.every((option) => 'condition' in option)
      if (hasCondition === true) {
        return this.options.filter((option) => option.condition === true)
      } else {
        return this.options
      }
    }
  },
  methods: {
    handleClick (action) {
      action()
    }
  },
  watch: {
    open (val) {
      if (val === false) {
        this.$emit('close')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.v-list {
  background: #1e1e1e0a;
}
</style>
